import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import AuditAction from '@/audit//components/AuditAction';
import { readStates } from '@/constants/lifecycle';
import { datasetUrl } from '@/constants/urls';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import ShareDatasetAction from '../../sharing/containers/ShareDatasetAction';
import { confirmDatasetDeletion } from '../../actions';
import { datasetPerms } from '../../sharing/state/state';
import datasetNotificationSettings from '../helper';
import { datasetSettingsFields } from '../state/state';
import DatasetNotificationSubscribersAction from '../../notifications/components/DatasetNotificationSubscribersAction';
import DatasourceAction from '../../datasource/containers/DatasourceAction';
import DataManagementAction from '../../data/components/DataManagementAction';
import DatasetNotificationSendAction from '../../notifications/components/DatasetNotificationSendAction';
import { datasetAdminPermissions, datasetManagePermissions } from '../../sharing/constants';
import canManageDataset from '../../sharing/helper';
import { datasourceFields } from '../../datasource/state/state';
import { datasourceSupportsManagement } from '../../datasource/helper';

const accessControl = (role, perms) => {
  const { datasets } = role.permissions;
  return ({
    allowAudit: datasets.audit && perms[datasetAdminPermissions.AUDIT],
    allowDatasource: datasets.update && perms[datasetAdminPermissions.DATASOURCE],
    allowDelete: datasets.destroy && perms[datasetAdminPermissions.DESTROY],
    allowSecure: datasets.secure && perms[datasetManagePermissions.SECURITY],
    allowData: datasets.update && canManageDataset(perms),
    allowShare: datasets.share && (perms[datasetManagePermissions.INVITE_MEMBER]
            || perms[datasetManagePermissions.REMOVE_MEMBER]),
  });
};

const withoutItem = (role, perms) => ({
  exists: false,
  url: '',
  name: '',
  ...readStates,
  notifyAllowed: false,
  ...accessControl(role, perms),
});

const withItem = (catalogue, settings, perms, role, datasourceFeatures) => ({
  exists: true,
  url: datasetUrl(catalogue, '#'),
  name: catalogue.catalogue.title,
  readStatus: catalogue.readStatus,
  ...accessControl(role, perms),
  ...datasetNotificationSettings({ settings, permissions: perms }),
  supportsManagement: datasourceSupportsManagement(datasourceFeatures) && datasourceFeatures.managed_data,
});

const DatasetAdminActions = ({
  allowAudit,
  allowData,
  allowDatasource,
  allowDelete,
  allowSecure,
  allowShare,
  category,
  code,
  name,
  notifyAllowed,
  showDelete,
  supportsManagement,
  url,
}) => (
  <>
    <ShareDatasetAction
      code={code}
      category={category}
      secureOnly={allowSecure && !allowShare}
      disabled={!allowShare && !allowSecure}
    />
    <DatasourceAction code={code} name={name} disabled={!allowDatasource} />
    <DatasetNotificationSendAction code={code} name={name} disabled={!notifyAllowed} />
    <DatasetNotificationSubscribersAction code={code} disabled={!notifyAllowed} />
    {/* Hide if Does not support Validate */}
    { supportsManagement && <DataManagementAction code={code} disabled={!allowData} /> }
    <AuditAction baseUrl={url} disabled={!allowAudit} />
    <DeleteActionMenu onClick={() => showDelete({ code, catalogue: { title: name } })} disabled={!allowDelete} />
  </>
);

const mapStateToProps = ({
  auth: { role },
  catalogues: { catalogues },
  datasetSettings: { settings },
  datasetUsers: { permissions },
  datasetDatasource: { features },
}, { category, code }) => {
  const catalogue = findResult(catalogues, category, code);
  const item = findResult(settings, category, code) || datasetSettingsFields();
  const perms = findResult(permissions, category, code) || datasetPerms();
  const datasourceFeatures = findResult(features, category, code)
      || { ...datasourceFields() };
  return catalogue ? withItem(catalogue, item, perms, role, datasourceFeatures) : withoutItem(role, perms);
};

const mapDispatchToProps = {
  showDelete: confirmDatasetDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetAdminActions);
